import {
  Alert,
  Box,
  Button,
  Card,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Switch,
  TextField,
  Typography,
  useTheme,
} from "@mui/material";
import { useEffect, useState } from "react";
import { useAuth } from "../../services/auth";
import { useNavigate, useParams } from "react-router-dom";
import * as Yup from "yup";
import { useForm } from "react-hook-form";
import fields from "./fields";
import { yupResolver } from "@hookform/resolvers/yup";
import { createYupSchema } from "../../utilities/yupSchemaCreator";
import styled from "styled-components";
import ErrorsList from "../../ui/ErrorsList";
import { useAccount } from "./provider";

const yupSchema = fields.reduce(createYupSchema, {});
const formSchema = Yup.object().shape(yupSchema);

const ButtonWrapper = styled.div`
  margin-bottom: 50px;
  button {
    float: right;
    margin-left: 20px;
  }
`;
const FormAccount = ({ handleSuccess, account }) => {
  let { role } = useAuth();
  let navigate = useNavigate();
  const { id } = useParams();
  let theme = useTheme();
  const [error, setError] = useState(null);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(formSchema),
  });

  const { create, edit } = useAccount();

  useEffect(() => {
    setValue("siteId", id);
  }, [id]);

  const onSubmit = async (values) => {
    try {
      if (account) {
        await edit(values, account?.id);
      } else {
        await create(values);
      }
      handleSuccess();
    } catch (error) {
      setError({ title: error.errors.message });
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} noValidate>
      {error ? (
        <Alert severity="error" sx={{ my: 3 }}>
          <ErrorsList error={error} />
        </Alert>
      ) : (
        ""
      )}
      <Card
        sx={{
          p: theme.dimensions.padding,
          mt: theme.dimensions.mt,
          mb: theme.dimensions.mb,
        }}
      >
        <Typography variant="Poster" mb={3} component="h4" gutterBottom>
          Account Details
        </Typography>

        {fields.map((f, index) => (
          <Box key={index}>
            {f.switch ? (
              <FormGroup>
                <FormLabel
                  component="legend"
                  sx={{
                    mt: theme.dimensions.mt,
                  }}
                >
                  {f.label}
                </FormLabel>
                <FormControlLabel
                  sx={{
                    mt: theme.dimensions.mt,
                  }}
                  control={<Switch color="success" defaultChecked />}
                  {...register(f?.name)}
                  label="Active"
                />
              </FormGroup>
            ) : (
              <TextField
                label={f.label}
                name={f.name}
                error={!!errors[f.name]}
                helperText={errors[f.name]?.message}
                select={f.select}
                className={f.class}
                fullWidth
                required
                disabled={f.disabled}
                sx={{
                  width: theme.dimensions.width,
                  mt: theme.dimensions.mt,
                  mb: theme.dimensions.mb,
                }}
                inputProps={{
                  ...register(f?.name),
                  required: f.required,
                }}
                size="small"
              />
            )}
          </Box>
        ))}
      </Card>
      <ButtonWrapper>
        <Button
          variant="contained"
          type="submit"
          sx={{
            backgroundColor: theme.color.blackBackground,
            ml: theme.dimensions.ml,
            "&:hover": { background: `${theme.color.black}` },
          }}
        >
          Add Account
        </Button>
        <Button
          variant="contained"
          onClick={() => navigate(-1)}
          sx={{
            backgroundColor: theme.color.grayBackground,
            color: theme.color.dark,
            "&:hover": { background: `${theme.color.gray50}` },
          }}
        >
          Discard
        </Button>
      </ButtonWrapper>
    </form>
  );
};

export default FormAccount;
